import { render, staticRenderFns } from "./commonRouterView.vue?vue&type=template&id=a7a1b4c6&scoped=true&lang=pug"
import script from "./commonRouterView.vue?vue&type=script&lang=js"
export * from "./commonRouterView.vue?vue&type=script&lang=js"
import style0 from "./commonRouterView.vue?vue&type=style&index=0&id=a7a1b4c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a1b4c6",
  null
  
)

export default component.exports